<template>
  <div class="pa-7" id="support-summary">
    <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--カードコンポーネントをfor文で増やす-->
    <v-row>
      <v-col
      :cols="item.col"
      v-for="(item, i) in contents"
      :key="i"
      col="12">
        <v-card
        class="pa-5 ma-2"
        height="100%"
        elevation="5">
          <!--タイトル-->
          <v-card-title
          class="head2">
            {{ item.title }}
          </v-card-title>
          <!--サブタイトル-->
          <v-card-subtitle v-if="item.hasSubtitle">
            {{ item.subtitle }}
          </v-card-subtitle>
          <!--箇条書き部分-->
          <div
          v-for="(list, i) in item.content"
          :key="i"
          class="pt-2 ml-1">
            {{ list.li }}
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '概要',
      // タイトル横のアイコン
      icon: 'mdi-message-bulleted',
      // カードコンポーネントの内用
      contents: [
        {
          // 幅(最大12)
          col: '12',
          // タイトル
          title: '標準的な学会サイトコンテンツ',
          // サブタイトルがあるか
          hasSubtitle: 'true',
          // サブタイトル内容
          subtitle: '学会ホームページの一般的な構成は、次のような内容です。下記の内容を標準提供いたします。',
          // 箇条書きの内容
          content: [
            {
              li: 'トップページ'
            },
            {
              li: '学術集会会長挨拶ページ'
            },
            {
              li: '開催概要ページ'
            },
            {
              li: '参加者へのご案内ページ'
            },
            {
              li: '演題登録方法の案内ページ'
            },
            {
              li: 'プログラムページ'
            },
            {
              li: '会場アクセスページ'
            },
            {
              li: 'リンクページ'
            },
            {
              li: '協賛金についてページ'
            }
          ]
        },
        {
          // 幅(最大12)
          col: '12',
          // タイトル
          title: 'その他ご提供できるサービス',
          // サブタイトルがあるか
          hasSubtitle: 'false',
          // 箇条書きの内容
          content: [
            {
              li: 'スマートフォン対応のレスポンシブWEBデザイン'
            },
            {
              li: '事前登録システム'
            },
            {
              li: '演題登録システム'
            },
            {
              li: '学会用Facebook、X（旧Twitter）の運用サポート'
            },
            {
              li: 'iPad、Android端末専用の学会アプリも作成いたします'
            }
          ]
        },
        {
          // 幅(最大12)
          col: '12',
          xl: '6',
          // タイトル
          title: '費用について',
          // サブタイトルがあるか
          hasSubtitle: 'false',
          // 箇条書きの内容
          content: [
            {
              li: 'ページに使用する画像・文章をご用意いただいた場合、お得な価格設定をご用意いたしております'
            },
            {
              li: '学会開催 3回、5回 実施分を、まとめてサポートするパック契約（CMS利用）もご利用頂けます'
            }
          ]
        }
      ]
    }
  }
}
</script>
